export const fieldNames = {
  availableForClient: 'availableForClient',
  note: 'note',
};
